export default /* glsl */`
#ifdef USE_MAP

	float tintAccumulatedInfluence = tintInfluence;

	vec2 resolution = vec2(10.0, 10.0);
	float frequency1 = 10.03;
    float frequency2 = 10.05;
    float speed = 0.5;

	vec2 st = vUv/resolution.xy;

    // Scale the coordinate system to see
    // some noise in action
    vec2 pos = vec2(st*1.0);

    // Oscillate vertices up/down
    float xN = (sin(pos.x * frequency1 + time * speed) * 0.5 + 0.5);

    // Oscillate vertices inside/outside
    float yN = (sin(pos.y * frequency2 + time * speed) * 0.5 + 0.5);

    // Use the noise function
    // float n = turbulence(vec3(pos, time * speed));
    float n = xN * yN;

    tintAccumulatedInfluence *= 1.0 - 0.25 * n * animInfluence;

#endif
`;
